import React from "react";

const PPPDomainsSection = () => {
  const domains = [
    {
      title: "Defense & Industrial Manufacturing",
      icon: "🛡️",
      description: "Strategic defense partnerships and industrial manufacturing initiatives"
    },
    {
      title: "Transportation & Logistics",
      icon: "🚛",
      description: "Infrastructure development for transport networks and logistics hubs"
    },
    {
      title: "Healthcare & Medical Facilities",
      icon: "🏥",
      description: "Healthcare infrastructure and medical facility development"
    },
    {
      title: "Education & Vocational Training",
      icon: "🎓",
      description: "Educational infrastructure and vocational training programs"
    },
    {
      title: "Energy, Water & Waste Management",
      icon: "⚡",
      description: "Sustainable energy, water resources, and waste management solutions"
    },
    {
      title: "Municipal & Urban Development",
      icon: "🏙️",
      description: "Smart city initiatives and urban development projects"
    },
    {
      title: "Digital Infrastructure & Smart City Solutions",
      icon: "💻",
      description: "Digital transformation and smart city technology implementation"
    },
    {
      title: "Agriculture & Food Security",
      icon: "🌾",
      description: "Agricultural development and food security initiatives"
    }
  ];

  return (
    <section
      className="relative py-12 sm:py-16 md:py-20"
      style={{
        background: "linear-gradient(to bottom, #c99c48 0%, #8b7035 50%, #4a4a4a 100%)",
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 sm:mb-12" data-aos="fade-up">
            <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              Targeted PPP Domains
            </h2>
            <p className="text-sm xs:text-base sm:text-lg text-gray-100 mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed">
              We actively pursue opportunities across diverse sectors to support Saudi Arabia's Vision 2030
            </p>
            <div className="w-12 sm:w-16 md:w-24 h-1 bg-white mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {domains.map((domain, index) => (
              <div
                key={index}
                className="bg-white bg-opacity-10 backdrop-blur-sm rounded-lg p-4 sm:p-6 text-center transition-all duration-300 transform hover:-translate-y-2 hover:scale-105 hover:shadow-lg border border-white/10"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">{domain.icon}</div>
                <h3 className="text-sm sm:text-base md:text-lg font-bold text-white mb-2 sm:mb-3 leading-tight">
                  {domain.title}
                </h3>
                <p className="text-gray-100 text-xs sm:text-sm leading-relaxed">
                  {domain.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPPDomainsSection;
